import { moveItemInArray, transferArrayItem, type CdkDragDrop } from "@angular/cdk/drag-drop";
import { VERSION } from "@angular/core";
import { PickList } from "primeng/picklist";

if (VERSION.major === "19") {
  /* eslint-disable -- not our code */

  PickList.prototype.onDrop = function (this: PickList, event: CdkDragDrop<string[]>, listType: number): void {
    let isTransfer = event.previousContainer !== event.container;
    let dropIndexes = this.getDropIndexes(
      event.previousIndex,
      event.currentIndex,
      listType,
      isTransfer,
      event.item.data
    );

    if (listType === this.SOURCE_LIST) {
      if (isTransfer) {
        // https://github.com/primefaces/primeng/issues/17966#issuecomment-2980699818
        transferArrayItem(this.target, this.source, dropIndexes.previousIndex, dropIndexes.currentIndex);
        let selectedItemIndex = this.findIndexInList(event.item.data, this.selectedItemsTarget);

        if (selectedItemIndex != -1) {
          this.selectedItemsTarget.splice(selectedItemIndex, 1);

          if (this.keepSelection) {
            this.selectedItemsTarget.push(event.item.data);
          }
        }

        if (this.visibleOptionsTarget) this.visibleOptionsTarget.splice(event.previousIndex, 1);

        this.onMoveToSource.emit({ items: [event.item.data] });
      } else {
        moveItemInArray(event.container.data, dropIndexes.previousIndex, dropIndexes.currentIndex);
        this.onSourceReorder.emit({ items: [event.item.data] });
      }

      if (this.filterValueSource) {
        this.filter(<any[]>this.source, this.SOURCE_LIST);
      }
    } else {
      if (isTransfer) {
        // https://github.com/primefaces/primeng/issues/17966#issuecomment-2980699818
        transferArrayItem(this.source, this.target, dropIndexes.previousIndex, dropIndexes.currentIndex);

        let selectedItemIndex = this.findIndexInList(event.item.data, this.selectedItemsSource);

        if (selectedItemIndex != -1) {
          this.selectedItemsSource.splice(selectedItemIndex, 1);

          if (this.keepSelection) {
            this.selectedItemsTarget.push(event.item.data);
          }
        }

        if (this.visibleOptionsSource) this.visibleOptionsSource.splice(event.previousIndex, 1);

        this.onMoveToTarget.emit({ items: [event.item.data] });
      } else {
        moveItemInArray(event.container.data, dropIndexes.previousIndex, dropIndexes.currentIndex);
        this.onTargetReorder.emit({ items: [event.item.data] });
      }

      if (this.filterValueTarget) {
        this.filter(<any[]>this.target, this.TARGET_LIST);
      }
    }
  };

  // https://github.com/primefaces/primeng/issues/18388#issuecomment-2996391412
  PickList.prototype.triggerChangeDetection = function (this: PickList) {
    this.selectedItemsSource = [...this.selectedItemsSource];
    this.selectedItemsTarget = [...this.selectedItemsTarget];
  };

  /* eslint-enable */
} else {
  // eslint-disable-next-line no-console
  console.warn("Skipping the picklist fix — it only works for PrimeNG 19 and might be obsolete now.");
}
